import React, { useState, useEffect, useContext } from 'react';
import "./AccountSettings.css";
import profile_ from "../../assets/images/profile_.png";
import { Autocomplete, CircularProgress, InputAdornment, Skeleton, TextField } from '@mui/material';
import MyContext from '../../Context/AppContext';
import { showToast } from '../../utils/toastUtils';
import updateUserData from '../../Apis/UpdateUserData';
import 'react-phone-number-input/style.css'
import PhoneInput, { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import { countries, getCountryCode, getCountryData } from 'countries-list'

const AccountSettings = () => {
    const { openDrawer, userDetails, setUserDetails } = useContext(MyContext);
    const [imagePreview, setImagePreview] = useState(profile_);
    const [userDetailsData, setUserDetailsData] = useState({
        name: '',
        email: '',
        distEmail: '',
        orgName: '',
        role: '',
        countryCode: '',
        phoneNumber: '',
        isDistEmailEditable: false,
        country: ''
    })
    const [updateDisabled, setUpdateDisabled] = useState(true)
    const [userDetailsUpdating, setUserDetailsUpdating] = useState(false)
    const [userDataFetching, setUserDataFetching] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('')
    const [defaultCountryIsoCode, setDefaultCountryIsoCode] = useState('')
    const [fieldValidation, setFieldValidation] = useState({
        isDistEmailValid: true,
        isPhoneNumberValid: true
    })

    const fetchUserDetails = async () => {
        setUserDetailsData({
            name: userDetails?.name,
            email: userDetails?.email,
            distEmail: userDetails?.distEmail,
            orgName: userDetails?.orgName,
            role: userDetails?.role,
            countryCode: userDetails?.countryCode,
            phoneNumber: userDetails?.phoneNumber,
            isDistEmailEditable: userDetails?.isDistEditable,
            country: getCountryData(userDetails?.countryISO)
        })
        setDefaultCountryIsoCode(userDetails?.countryISO)
        setPhoneNumber(userDetails?.countryCode + " " + userDetails?.phoneNumber)
    }

    const userDetailChangeHandler = (e, fieldName) => {
        const value = e.target.value
        setUserDetailsData({ ...userDetailsData, [fieldName]: value })
        setUpdateDisabled(false)
    }

    const updateProfileHandler = async () => {
        try {
            if (!fieldValidation.isPhoneNumberValid) {
                showToast('Please enter a valid phone number', 'error')
                return
            }
            else if (!fieldValidation.isDistEmailValid) {
                showToast('Please enter a valid email address', 'error')
                return
            }
            else if (!isCorporateMailAddress(userDetailsData.distEmail)) {
                showToast('Apologies! The distribution email must be a valid company email address.', 'error')
                setFieldValidation({ ...fieldValidation, isDistEmailValid: false })
                return
            }
            else if (userDetailsData?.name === '' || userDetailsData?.distEmail === '' || userDetailsData?.orgName === '' ||
                userDetailsData?.role === '' || userDetailsData?.phoneNumber === '' || userDetailsData?.countryCode === ''
                || userDetailsData?.country === ''
            ) {
                showToast('All fields are mandatory', 'error')
                return
            }
            setUpdateDisabled(true)
            setUserDetailsUpdating(true)
            let payload = {
                name: userDetailsData?.name,
                distEmail: userDetailsData?.distEmail,
                orgName: userDetailsData?.orgName,
                role: userDetailsData?.role,
                phoneNumber: userDetailsData?.phoneNumber,
                countryCode: userDetailsData?.countryCode,
                countryISO: getCountryCode(userDetailsData?.country?.name)
            }
            let response = await updateUserData(payload, userDetails?._id)
            if (response?.status === 200) {
                showToast('User details updated successfully!!', 'success')
                setUserDetails(response?.data)
            }
            else {
                let errMessage = response?.response?.data?.detail || 'User details update failed'
                showToast(errMessage, 'error')
            }
        } catch (error) {
            console.log(error)
            showToast('User details update failed', 'error')
        }
        finally {
            setUserDetailsUpdating(false)
        }
    }

    const keypressHandler = (e) => {
        var invalidChars = [
            "-",
            "+",
            "e",
        ];
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
    }

    const isCorporateMailAddress = (email) => {
        if (email.includes("gmail") ||
            email.includes("outlook") ||
            email.includes("yahoo") ||
            email.includes("hotmail") ||
            email.includes("icloud") ||
            email.includes("zoho") ||
            email.includes("protonmail")
        )
            return false
        else
            return true
    }


    const phoneNumberChangeHandler = (val) => {
        setPhoneNumber(val)
        setUpdateDisabled(false)
        if (val) {
            if (val && isPossiblePhoneNumber(val)) {
                setFieldValidation({ ...fieldValidation, isPhoneNumberValid: true })
                let countryCode_PhoneNumber = `+${parsePhoneNumber(val).countryCallingCode}`
                setUserDetailsData({ ...userDetailsData, phoneNumber: val.replace(countryCode_PhoneNumber, ""), countryCode: countryCode_PhoneNumber })
            }
            else {
                setFieldValidation({ ...fieldValidation, isPhoneNumberValid: false })
            }
        }
        else {
            setFieldValidation({ ...fieldValidation, isPhoneNumberValid: true })
            setUserDetailsData({ ...userDetailsData, phoneNumber: "", countryCode: "" })
        }
    };

    const countryChangeHandler = (value) => {
        setUpdateDisabled(false)
        if (value) {
            setUserDetailsData({ ...userDetailsData, country: value })
            let countryIsoCode = getCountryCode(value.name)
            setDefaultCountryIsoCode(countryIsoCode)
        }
        else {
            setUserDetailsData({ ...userDetailsData, country: '' })
        }
    }

    const validateEmail = (email) => {
        const regX =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (regX.test(email)) {
            return true;
        } else {
            return false;
        }
    };

    const distributionMailChangeHandler = (e) => {
        setUpdateDisabled(false)
        const emailValue = e.target.value
        if (emailValue) {
            setUserDetailsData({ ...userDetailsData, distEmail: emailValue })
            if (validateEmail(emailValue)) {
                setFieldValidation({ ...fieldValidation, isDistEmailValid: true })
            }
            else {
                setFieldValidation({ ...fieldValidation, isDistEmailValid: false })
            }
        }
        else {
            setUserDetailsData({ ...userDetailsData, distEmail: '' })
            setFieldValidation({ ...fieldValidation, isDistEmailValid: true })
        }
    }


    useEffect(() => {
        fetchUserDetails()
    }, [])

    return (
        <div className={openDrawer ? 'mainContainer_accountSettings drawerOpen_AccountSettings' : 'mainContainer_accountSettings'}>
            <div className='mainDiv_accountSettings'>
                <div className='topTitleContainer_AccountSettings'>
                    <span className='accountSetting_title'>Account Information</span>
                    {userDataFetching ? null :
                        <span className='accountType'>({userDetails?.accountTypeInfo?.typename})</span>
                    }
                </div>
                <img alt="Profile" src={imagePreview} className="profile-image" />
                <div className='accountDetailsContainer'>
                    <div className='detailItems'>
                        <span>Full Name</span>
                        <TextField
                            className='inputField'
                            id="outlined-basic"
                            variant="outlined"
                            value={userDataFetching ? 'Loading...' : userDetailsData?.name}
                            onChange={(e) => userDetailChangeHandler(e, 'name')}
                            disabled={userDataFetching}
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end">
                                        {userDataFetching && <CircularProgress size={20} />}
                                    </InputAdornment>,
                                },
                            }}
                        />
                    </div>
                    <div className='detailItems'>
                        <span>Primary Email</span>
                        <TextField
                            className='inputField'
                            id="outlined-basic"
                            variant="outlined"
                            value={userDataFetching ? 'Loading...' : userDetailsData?.email}
                            disabled
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end">
                                        {userDataFetching && <CircularProgress size={20} />}
                                    </InputAdornment>,
                                },
                            }}
                        />
                    </div>
                    <div className='detailItems'>
                        <span>Distribution Email</span>
                        <TextField
                            className={fieldValidation.isDistEmailValid ? 'inputField' : 'inputField invalidField_signup'}
                            id="outlined-basic"
                            variant="outlined"
                            value={userDataFetching ? 'Loading...' : userDetailsData?.distEmail}
                            onChange={(e) => distributionMailChangeHandler(e)}
                            disabled={userDataFetching || !userDetailsData?.isDistEmailEditable}
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end">
                                        {userDataFetching && <CircularProgress size={20} />}
                                    </InputAdornment>,
                                },
                            }}
                        />
                        {(!fieldValidation.isDistEmailValid) ? (
                            <span className="invalidPhoneError">
                                *Invalid email address
                            </span>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className='detailItems'>
                        <span>Country</span>
                        <Autocomplete
                            className='autocomplete_accountSettings'
                            options={Object.values(countries) || []}
                            getOptionLabel={(option) => option.name || ''}
                            value={userDetailsData?.country}
                            onChange={(e, value) => countryChangeHandler(value)}
                            loading={userDataFetching}
                            disabled={userDataFetching}
                            renderInput={(params) => <TextField
                                slotProps={{
                                    input: {
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {userDataFetching ? <CircularProgress size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    },
                                }}
                                placeholder='Select country...'
                                {...params}
                            />}
                        />
                    </div>
                    <div className='detailItems phoneInput_accountSettings'>
                        <span>Phone Number</span>
                        <PhoneInput
                            international
                            defaultCountry={defaultCountryIsoCode}
                            className={fieldValidation.isPhoneNumberValid ? "textbox_phone_input_accountSettings" : "textbox_phone_input_accountSettings invalidField_signup"}
                            value={phoneNumber}
                            onChange={(e) => phoneNumberChangeHandler(e)}
                            onKeyPress={(e) => keypressHandler(e)}
                            placeholder="Enter phone number..."
                        />
                        {(!fieldValidation.isPhoneNumberValid) ? (
                            <span className="invalidPhoneError">
                                *Invalid phone number
                            </span>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className='detailItems'>
                        <span>Organization Name</span>
                        <TextField
                            className='inputField'
                            id="outlined-basic"
                            variant="outlined"
                            value={userDataFetching ? 'Loading...' : userDetailsData?.orgName}
                            onChange={(e) => userDetailChangeHandler(e, 'orgName')}
                            disabled={userDataFetching}
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end">
                                        {userDataFetching && <CircularProgress size={20} />}
                                    </InputAdornment>,
                                },
                            }}
                        />
                    </div>
                    <div className='detailItems'>
                        <span>Role</span>
                        <TextField
                            className='inputField'
                            id="outlined-basic"
                            variant="outlined"
                            value={userDataFetching ? 'Loading...' : userDetailsData.role}
                            onChange={(e) => userDetailChangeHandler(e, 'role')}
                            disabled={userDataFetching}
                            slotProps={{
                                input: {
                                    endAdornment: <InputAdornment position="end">
                                        {userDataFetching && <CircularProgress size={20} />}
                                    </InputAdornment>,
                                },
                            }}
                        />
                    </div>
                </div>
                <div className='updateButtonContainer'>
                    <button className={updateDisabled ? 'updateButton_accountSettings  buttondisabled' : 'updateButton_accountSettings'}
                        onClick={updateProfileHandler}
                        disabled={updateDisabled}
                    >
                        {userDetailsUpdating && <CircularProgress className='cp_loginButton' />}
                        <span>{userDetailsUpdating ? "Please wait..." : "Update Profile"}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccountSettings;
